import InformationBar from "../../../components/InformationBar/InformationBar";
import StepBar from "../../../components/StepBar/StepBar";
import {useEffect, useState} from "react";
import DatiPersonali from "./WizardSteps/DatiPersonali/DatiPersonali";
import LavoroDisponibilita from "./WizardSteps/LavoroDisponibilita/LavoroDisponibilita";
import RequisitiCondizioni from "./WizardSteps/RequisitiCondizioni/RequisitiCondizioni";
import {useHistory} from "react-router";
import Spinner from "../../../components/spinner/Spinner";
import InfoPercorso from "../../../components/InfoPercorso/InfoPercorso";
import {useSelector} from "react-redux";

function WizardRegistro (props){

    const [currentStep,setCurrentStep] = useState(null)
    const [codiceCurrentStep,setCodiceCurrentStep] = useState("01")
    const [steps,setSteps] = useState([{nome:"1. DATI PERSONALI",codiceStep:"01",cliccabile:false},{nome:"2. LAVORO E DISPONIBILITA'",codiceStep:"02",cliccabile:false},{nome:"3. REQUISITI E CONDIZIONI",codiceStep:"03",cliccabile:false}])
    const [showSpinner,setShowSpinner] = useState(false)
    const history = useHistory()
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}


    useEffect(() => {
        if(history && history.location) {
            if (history.location.steps && history.location.stepAttivo) {
                setSteps(history.location.steps)
                renderStep(history.location.stepAttivo)
            } else {
                renderStep(codiceCurrentStep)
            }
        }
    }, [props])


    function renderStep(codiceStep){
        setShowSpinner(true)
        setCodiceCurrentStep(codiceStep)
        switch (codiceStep) {
            case "01": {
                let newCurrentStep = (
                    <div><DatiPersonali datiAnagrafici={history && history.location && history.location.datiAnagrafici}/></div>
                )
                setCurrentStep(newCurrentStep)
                break;
            }
            case "02": {
                let newCurrentStep = (
                    <div><LavoroDisponibilita/></div>
                )
                setCurrentStep(newCurrentStep)
                break;
            }
            case "03": {
                let newCurrentStep = (
                    <div><RequisitiCondizioni/></div>
                )
                setCurrentStep(newCurrentStep)
                break;
            }
            default: {
                let newCurrentStep = (
                    <div><DatiPersonali/></div>
                )
                setCurrentStep(newCurrentStep)
                break;
            }
        }
        setShowSpinner(false)
    }

    return (
        <div>
            <Spinner show={showSpinner}/>
            <InfoPercorso percorso={["Registro",getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato?"Modifica Record":"Nuovo Record"]}/>
            <InformationBar/>
            <StepBar steps={steps} stepAttivo={codiceCurrentStep} col={"col-4"} path={sessioneUtente && sessioneUtente.tipoUtente !== "01"?"/profilo":"/wizardRegistro"}/>
            {currentStep}
        </div>

    )







}
export default WizardRegistro
